module.exports = "/_next/static/images/footer-shapes-592c4c3e3823bf9c8bfd0b422fae62cb.png";